import { useState } from "react";
import { ChevronLeft, ChevronRight, Quote } from "lucide-react";

const quotes = [
  {
    body:
      "Working with Noa felt like finally having someone in my corner who actually got my brain. The strategies are practical and the partnership is the part that changed everything.",
    name: "Parent of an 11-year-old",
    role: "1:1 Parent Coaching",
  },
  {
    body:
      "I came in stuck and overwhelmed and left with a plan I was actually excited about. Noa helps you build systems that bend with your life, not against it.",
    name: "Adult with ADHD",
    role: "1:1 Adult Coaching",
  },
  {
    body:
      "Our team walked away with concrete, ADHD-friendly tools. The session was warm, lively, and full of immediately usable ideas.",
    name: "Elementary educator",
    role: "Group Training",
  },
];

export default function Testimonials() {
  const [i, setI] = useState(0);
  const next = () => setI((p) => (p + 1) % quotes.length);
  const prev = () => setI((p) => (p - 1 + quotes.length) % quotes.length);
  const q = quotes[i];

  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="py-24 md:py-32"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <div
          className="reveal rounded-[36px] p-10 md:p-16 lg:p-20 relative overflow-hidden"
          style={{ backgroundColor: "#7c8b84" }}
        >
          <div
            aria-hidden
            className="absolute -top-24 -right-24 w-[360px] h-[360px] rounded-full opacity-30 blur-3xl"
            style={{ background: "radial-gradient(closest-side, #d9b86a, transparent)" }}
          />

          <div className="relative">
            <span className="text-xs md:text-sm uppercase tracking-[0.28em] text-brand-cream/80 font-semibold">
              Kind words
            </span>
            <Quote className="text-brand-gold mt-6" size={36} strokeWidth={1.4} />

            <blockquote
              data-testid="testimonial-quote"
              className="mt-6 font-serif text-3xl md:text-4xl lg:text-5xl leading-[1.15] text-brand-cream max-w-4xl"
            >
              "{q.body}"
            </blockquote>

            <div className="mt-10 flex items-end justify-between gap-6 flex-wrap">
              <div>
                <div className="font-serif text-xl md:text-2xl text-brand-cream italic">
                  {q.name}
                </div>
                <div className="text-xs md:text-sm uppercase tracking-[0.2em] text-brand-gold mt-1">
                  {q.role}
                </div>
              </div>
              <div className="flex items-center gap-3">
                <button
                  onClick={prev}
                  aria-label="Previous testimonial"
                  data-testid="testimonial-prev"
                  className="rounded-full w-12 h-12 flex items-center justify-center bg-brand-cream/10 hover:bg-brand-cream/20 text-brand-cream transition border border-brand-cream/20"
                >
                  <ChevronLeft size={18} />
                </button>
                <button
                  onClick={next}
                  aria-label="Next testimonial"
                  data-testid="testimonial-next"
                  className="rounded-full w-12 h-12 flex items-center justify-center bg-brand-cream text-brand-sageDeep hover:bg-brand-gold transition"
                >
                  <ChevronRight size={18} />
                </button>
              </div>
            </div>

            <div className="mt-6 flex gap-2">
              {quotes.map((_, idx) => (
                <button
                  key={idx}
                  aria-label={`Go to testimonial ${idx + 1}`}
                  data-testid={`testimonial-dot-${idx}`}
                  onClick={() => setI(idx)}
                  className={`h-1.5 rounded-full transition-all ${
                    idx === i ? "w-8 bg-brand-gold" : "w-3 bg-brand-cream/40"
                  }`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
